import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
const STORAGE_KEY = "pronostiek.pendingInviteToken";
export function readPendingInviteToken() {
    try {
        return sessionStorage.getItem(STORAGE_KEY);
    }
    catch {
        return null;
    }
}
export function clearPendingInviteToken() {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    }
    catch {
        // ignore
    }
}
export function InviteLandingPage() {
    const { t } = useTranslation();
    const { token } = useParams();
    const navigate = useNavigate();
    useEffect(() => {
        if (token && token.length >= 16 && /^[a-f0-9-]+$/i.test(token)) {
            try {
                sessionStorage.setItem(STORAGE_KEY, token);
            }
            catch {
                // ignore — fall back to manual paste
            }
        }
    }, [token]);
    const valid = Boolean(token && /^[a-f0-9-]+$/i.test(token) && token.length >= 16);
    return (_jsxs(_Fragment, { children: [_jsx("h2", { children: t("invite.heading") }), valid ? (_jsxs(_Fragment, { children: [_jsx("p", { className: "intro", children: t("invite.intro") }), _jsxs("div", { className: "card", children: [_jsx("p", { children: t("invite.tokenSaved") }), _jsx("p", { className: "footer-note", children: t("invite.howNext") })] }), _jsxs("div", { className: "row-stack", children: [_jsx("button", { onClick: () => navigate("/consent"), children: t("invite.accept") }), _jsx(Link, { to: "/welcome", children: _jsx("button", { className: "secondary", children: t("app.cancel") }) })] })] })) : (_jsxs(_Fragment, { children: [_jsx("div", { className: "banner error", children: t("invite.invalid") }), _jsx(Link, { to: "/welcome", children: _jsx("button", { children: t("invite.toWelcome") }) })] }))] }));
}
